import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const StickyMobileCTA = () => {
  const navigate = useNavigate();

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-black/95 backdrop-blur-md border-t border-white/10 px-4 py-3 safe-area-bottom"
    >
      <button
        onClick={() => window.open('https://www.weddingvideo.co.uk/contact', '_blank')}
        className="w-full bg-gold hover:bg-gold-light text-black font-bold py-3.5 rounded-xl transition-all flex items-center justify-center gap-2 text-sm"
      >
        Secure My Date <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default StickyMobileCTA;
